<template>
  <v-list three-line>
    <v-list-tile>
      <v-list-tile-avatar size="80" >
        <v-fade-transition mode="out-in">
          <v-img
            v-if="value"
            :src="$helpers.imageFrom(value)"
          />
          <span
            v-else
            class="text--disabled">{{ $t('no image') }}</span>
        </v-fade-transition>
      </v-list-tile-avatar>

      <v-list-tile-content class="logo-position">
        <v-layout
          align-center
          justify-center
          row>
          <v-flex>
            <upload-button
              :loading="progress"
              :title="$t('Upload image file')"
              no-title-update
              class="file-upload-button"
              @file-update="update"
            />
          </v-flex>
          <v-flex class="text-uppercase">
            {{ $t('or') }}
          </v-flex>
          <v-flex class="pl-4">
            <v-text-field
              v-model="logoImage"
              :label="$t('Set your URL')"
              @change="change"/>
          </v-flex>
        </v-layout>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import UploadButton from 'vuetify-upload-button'

export default {
  name: 'ImageUpload',

  components: {
    UploadButton
  },

  props: {
    value: {
      type: [String, null],
      default: null
    }
  },

  data () {
    return {
      progress: false,
      logoImage: '',
      previousImage: this.value
    }
  },

  methods: {
    update (file) {
      this.progress = true
      this.upload(file)
        .then(async res => {
          const response = res.data
          this.$emit('input', response.secure_url)
        })
        .catch(error => {
          this.$toast.error(this.$t(error.message))
        })
        .finally(() => {
          this.progress = false
        })
    },

    change () {
      if (!this.logoImage) {
        this.$emit('input', this.previousImage)
        return
      }
      this.$emit('input', this.logoImage)
    },

    async upload (file) {
      const cloudinary = await this.$http.make('general_settings').getCloudinary()
      const url = `https://api.cloudinary.com/v1_1/${cloudinary.name}/upload`

      const fd = new FormData()
      fd.append('upload_preset', cloudinary.preset)
      fd.append('tags', 'browser_upload') // Optional - add tag for image admin in Cloudinary
      fd.append('file', file)

      return require('axios').post(url, fd)
    }
  }
}
</script>

<style scoped>
.logo-position {
  margin-top: -15px
}
</style>
